export default {
    'aig': 'AIG',
    'akad': 'Akad',
    'allianz': 'Allianz',
    'allseg': 'Allseg',
    'american-life': 'American life',
    'anxo-capital': 'Anxo Capital',
    'argo': 'Argo',
    'austral': 'Austral',
    'avla': 'Avla',
    'axa': 'AXA',
    'axa-xl': 'AXA-XL',
    'bail': 'Bail',
    'berkley': 'Berkley',
    'bmg': 'BMG',
    'bradesco-seguros': 'Bradesco Seguros',
    'cesce': 'Cesce',
    'chubb': 'Chubb',
    'confianca-garantia': 'Confiança garantias e cauções',
    'columbia': 'Columbia',
    'dank': 'Dank',
    'darwin': 'Darwin',
    'daycoval': 'Daycoval',
    'essor': 'Essor',
    'euler-hermes': 'Euler-hermes',
    'excelsior': 'Excelsior',
    'ezze': 'EZZE',
    'fairfax': 'Fairfax',
    'fator': 'Fator',
    'faz-prime': 'Faz Prime',
    'fc-garantia': 'FC Garantia',
    'generali': 'Generali',
    'hastara-bank': 'Hastara Bank',
    'hdi': 'HDI',
    'infinite-bank': 'InfiniteBank',
    'infinite-seguradora': 'Infinite Seguradora',
    'investprev': 'Investprev',
    'itau': 'Itaú',
    'jns': 'JNS',
    'junto-seguros': 'Junto Seguros',
    'kovr': 'KOVR',
    'liberty': 'Liberty',
    'mapfre': 'Mapfre',
    'metlife': 'Metlife',
    'mitsui': 'Mitsui',
    'mongeral': 'Mongeral',
    'newe': 'Newe',
    'omint': 'Omint',
    'porto-seguro': 'Porto Seguro',
    'pottencial': 'Pottencial',
    'prudential': 'Prudential',
    'sancor': 'Sancor',
    'seguradora-alm': 'Seguradora ALM',
    'sombrero': 'Sombrero',
    'sompo': 'Sompo',
    'suhai': 'Suhai',
    'sulamerica': 'Sulamérica',
    'sura': 'Sura',
    'swiss-re': 'Swiss re',
    'tokio-marine': 'Tokio Marine',
    'too': 'Too Seguros',
    'unimed': 'Unimed',
    'yelum': 'Yelum',
    'zurich-santander': 'Zurich',
}